module.exports = __webpack_public_path__ + "static/media/Wsparcie_sprzedazy_1_A.4d1da768.png";